export default __webpack_public_path__ + "media/em-logo-small-gNrV4.svg";